import PageMainTitle from 'components/commons/PageMainTitle'
import styles from './Service.module.scss'
import ProductSolution from 'components/service/ProductSolution'
import { pageMainTitle } from 'components/service/Service/ServiceItems'
import DigitalInnovationSupport from 'components/service/DigitalInnovationSupport'
import DigitalPoC from 'components/service/DigitalPoC'
import ModernApplicationDevelopment from 'components/service/ModernApplicationDevelopment'
import MailmagazineLink from 'components/mailmagazine/MailmagazineLink/MailmagazineLink'

const Template: React.FC = () => {
  const paths = [
    { name: 'TOP', url: '/' },
    { name: 'Services', url: '#' },
  ]

  return (
    <>
      <PageMainTitle pageMainTitle={pageMainTitle} paths={paths} />
      <ModernApplicationDevelopment />
      <div className={styles.colored}>
        <DigitalPoC />
      </div>
      <DigitalInnovationSupport />
      <div className={styles.colored}>
        <ProductSolution />
      </div>
      <div className={styles.link_list}>
        <MailmagazineLink />
      </div>
    </>
  )
}

export default Template
